document.addEventListener('keydown', (event) => {
    // Check if Cmd (Mac) or Ctrl (Windows) + Enter is pressed
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {

        // Find the closest form to the element where the key was pressed
        const form = event.target.closest('form');

        // If the form exists, submit it
        if (form) {
            event.preventDefault(); // Prevent line break in textarea
            form.requestSubmit();   // Submit the form (with field validation)
        }
    }
});
